import React from 'react'
import getApplicableRegionPages from './helpers'
import { getRelativePath } from '../../helpers'
import SiteBanner from '../SiteBanner'
import { useCountryContext } from '../../../providers'

export default function RegionBanner() {
  const { preferredCountry } = useCountryContext()

  const applicablePages = getApplicableRegionPages(preferredCountry)
  if (!applicablePages.length) {
    return null
  }

  const { url, heading, dismissText, confirmText } = applicablePages[0]

  return (
    <div dir="auto">
      <SiteBanner
        type="info"
        heading={heading}
        storageKey="region-page"
        confirmProps={{ to: getRelativePath(url), children: confirmText }}
        dismissProps={{ children: dismissText }}
      />
    </div>
  )
}
